import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import StyledMainStage from './mainStage.style';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import LogoIcon from '../../icons/logo/logo';

const MainStage = ({ headline, introCopy }) => (
  <StyledMainStage>
    <div className="mainStage__background">
      <div className="mainStage__dots" />
    </div>
    <Container className="mainStage__wrapper">
      <div className="mainStage__headline">
        {headline && (
          <Headline tag="span" subline className="mainStage__subline">
            {headline}
          </Headline>
        )}
      </div>
    </Container>
    <div className="mainStage__logo">
      <div className="mainStage__logo-wrapper">
        <LogoIcon />
      </div>
    </div>
    <Container>
      <div className="mainStage__headline">
        {introCopy && <MixedCopy fullWidth html={introCopy} className="mainStage__copy" />}
      </div>
    </Container>
  </StyledMainStage>
);

MainStage.propTypes = {
  headline: PropTypes.string,
  introCopy: PropTypes.string
};

const mapStateToProps = ({ app }) => ({
  headline: app.pageData.headline,
  introCopy: app.pageData.introCopy
});

export default connect(mapStateToProps)(MainStage);
